<template>
  <tr :style="noborder?'border-bottom:none':''">
    <td colspan="2" data-label="姓名">
      <b-form-group horizontal :label-cols="5" :label="$lang('FIELD_NAME')" >
        <b-form-input
          class="input ui-autocomplete-input"
          type="text"
          style="    background: #fff !important;"
          v-model="value.name"
          name="name"
          :class="errors.has('name') && 'is-invalid'"
          v-validate="{ required: true }"
          :placeholder="$lang('')"
          :disabled="disabled"
        />
        <b-form-invalid-feedback :state="errors.has('name')">
          {{ errors.first("name") }}
        </b-form-invalid-feedback>
      </b-form-group>
    </td>
    <td ></td>
    <td colspan="2"  data-label="电话">
      <b-form-group  horizontal :label-cols="5" :label="$lang('FIELD_PHONE')" >
        <b-form-input
           style="    background: #fff !important;"
          type="text"
          v-model="value.phone"
          name="phone"
          :class="errors.has('phone') && 'is-invalid'"
          v-validate="'required|mobile'"
          :disabled="disabled"
        />
        <b-form-invalid-feedback :state="errors.has('phone')">
          {{ errors.first("phone") }}
        </b-form-invalid-feedback>
      </b-form-group>
    </td>
  </tr>
</template>

<script>
import InputFile from "./inputFile.vue";
export default {
  components: {
    InputFile,
  },
  props: {
    noborder:{},
    Index: {},
    keys: {},
    sportId: {},
    inputlist: {},
    index: String,
    value: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Object,
    },
    requiredType: {
      type: Boolean,
    },
  },
  data() {
    return {
      i: [],
      firstNamelist: [],
      idNumberlist: [],
      lastNamelist: [],
    };
  },
  mounted() {
  },
  computed: {},
  methods: {
    onSubmit() {
      return new Promise((resolve, reject) => {
        this.$validator.validate().then((result) => {
          // console.log(result);
          resolve(result);
        });
      });
    },
    validateErrors(field, msg) {
      this.errors.add({
        field,
        msg,
      });
    },
  },
};
</script>
<style lang="scss">
.pic img {
  margin: 0;
}
</style>